import WeblabHelper from './WeblabHelper';

class Locale {
  static getAvailableLocales(weblabs) {
    /*
     * Below list "availableLocales" consists of
     * all available locales including locales that
     * might be under weblab control for launch.
    */
    const availableLocales = ['en_US', 'fr_FR', 'de_DE', 'es_ES', 'it_IT', 'ja_JP', 'pt_BR'];
    /*
    * Below map "localeWeblabMap" consists of weblabs for locales.
    * For such cases, The locale is added to the below
    * map with the weblab value in the format "locale : weblab".
    * eg:
    * const localeWeblabMap = {
    *   LOCALE : 'WEBLAB_NAME',
    * };
    */
    const localeWeblabMap = {};
    return this.filterLocales(availableLocales, localeWeblabMap, weblabs);
  }

  static filterLocales(locales, localeWeblabMap, weblabs) {
    return locales.filter((locale) => {
      const localeWeblab = localeWeblabMap[locale];
      return typeof localeWeblab === 'undefined' || (weblabs && weblabs[localeWeblab]);
    });
  }

  static buildLocaleStringId(locale) {
    return `AA_Locale_${locale}`;
  }

  static buildNativeLocaleStringId(locale) {
    return `AA_Locale_${locale}_Native`;
  }

  static getLocaleBasedOnBrowserSetting() {
    const locale = ((navigator.languages && navigator.languages.length) ? navigator.languages[0]
      : navigator.userLanguage || navigator.language || navigator.browserLanguage || 'en_US').replace('-', '_');
    const supportedLocales = this.getAvailableLocales(WeblabHelper.getWeblabsMap());
    return supportedLocales.find(supportedLocale => supportedLocale === locale || supportedLocale.split(/-|_/)[0] === locale) || 'en_US';
  }
}

export default Locale;
